import React, {useEffect, useState} from 'react';
import {Box, Divider, Tab, Tabs, Toolbar, useMediaQuery} from "@mui/material";
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import {executeQueryUtil} from "../../utils/gqlUtil";
import {getChartCategoriesQuery} from "../../gql/chartCategoryGql";
import localStrings from "../../localStrings";
import {getChartImplementationsQuery} from "../../gql/chartImplementationGql";
import ChartPresentationItem from "./ChartPresentationItem";
import {getDataGridImplementationsQuery} from "../../gql/dataGridImplementationGql";

function ChartSelector({closeCallBack, addChartToBoardCallBack, addDataGridToBoardCallBack}) {

    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
    const [chartCategories, setChartCategories] = useState( null);
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const [chartAndDataGridImplementations, setChartAndDataGridImplementations] = React.useState(null);
    const [dataGridImplementations, setDataGridImplementations] = React.useState(null);

    const [currentTab, setCurrentTab] = useState('chartImplementation');

    const handleTabsChange = (event, value) => {
        setCurrentTab(value);
    };

    useEffect(() => {
        const loadData = async () => {
            let all = [];

            const res = await executeQueryUtil(getChartCategoriesQuery());
            setChartCategories(res.data.getChartCategories);

            const resChart = await executeQueryUtil(getChartImplementationsQuery());
            // all = all.concat(resChart.data.getChartImplementations);
            setChartAndDataGridImplementations(resChart.data.getChartImplementations)

            const resDataGrids = await executeQueryUtil(getDataGridImplementationsQuery());
            setDataGridImplementations(resDataGrids.data.getDataGridImplementations);
            // all = all.concat(resDataGrids.data.getDataGridImplementations);

            // setChartAndDataGridImplementations(all);


        }

        loadData();
    });

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
    };


    function getSelectedCaterory() {
        return chartCategories[selectedIndex];
    }

    function getChartImplementationsInCategory() {
        if (!getSelectedCaterory()) {
            return [];
        }
        const chartImplementationsInCategory = chartAndDataGridImplementations.filter((chartImplementation) => {
            return chartImplementation.chartCategoryId === getSelectedCaterory().id;
        })
        return chartImplementationsInCategory;
    }

    function getDataGridImplementationsInCategory() {
        if (!getSelectedCaterory()) {
            return [];
        }
        const dataGridImplementationsInCategory = dataGridImplementations.filter((chartImplementation) => {
            return chartImplementation.chartCategoryId === getSelectedCaterory().id;
        })
        return dataGridImplementationsInCategory;
    }



    return (
        <>
            {chartAndDataGridImplementations && chartCategories && dataGridImplementations &&
                <div style={{width: '100%'}}>

                    <Box
                        sx={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 2,
                            display: 'flex',
                            justifyContent: 'flex-end',
                            backgroundColor: 'transparent', // plus de fond blanc
                            padding: 0, // pas de padding
                        }}
                    >
                        <IconButton
                            aria-label="close"
                            onClick={() => {
                                closeCallBack();
                            }}
                            sx={(theme) => ({
                                color: theme.palette.grey[500],
                            })}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <div style={{height: '25px'}}></div>
                    <Box sx={{
                        width: '100%',
                        display: 'flex',
                    }}>

                        <Box
                            sx={{
                                position: 'sticky',
                                top: 0,
                                alignSelf: 'flex-start',
                                maxHeight: '100vh',
                                overflowY: 'hidden',
                                backgroundColor: 'white', // évite les superpositions transparentes
                                zIndex: 1, // au-dessus du fond si nécessaire
                                minWidth: lgUp ? '200px' : '120px', // largeur pour éviter que ça se réduise trop
                            }}
                        >
                            <Toolbar>
                                <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
                                    {localStrings.chartCategories}
                                </Typography>
                            </Toolbar>
                            <Divider/>



                            <MenuList>
                                {chartCategories.map((category, index) => {
                                    return (
                                        <MenuItem
                                            selected={index === selectedIndex}
                                            key={index}>
                                            <ListItemText

                                                onClick={(event) => handleMenuItemClick(event, index)}

                                            >
                                                {category.name}
                                            </ListItemText>
                                            {/*<Typography variant="body2" sx={{ color: 'text.secondary' }}>*/}
                                            {/*    ⌘X*/}
                                            {/*</Typography>*/}
                                        </MenuItem>
                                    )
                                })}
                            </MenuList>
                        </Box>
                        <Box style={{width: '10px'}}/>
                        <Box style={{width: '100%'}}>


                            <Toolbar sx={{

                            }}>
                                <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
                                    {getSelectedCaterory()?.name}
                                </Typography>
                            </Toolbar>

                            <Tabs
                                style={{marginLeft: '15px'}}
                                onChange={handleTabsChange}
                                scrollButtons="auto"
                                value={currentTab}
                                textColor="secondary"
                                variant="scrollable"

                            >
                                <Tab label={localStrings.chartImplementations} value="chartImplementation" />
                                <Tab label={localStrings.dataGridImplementations} value="dataGridImplementation" />
                            </Tabs>


                            {getChartImplementationsInCategory().length == 0 ?
                                <Box sx={{
                                    padding: '10px',
                                    width: '100%',
                                    height: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}>
                                    <div>
                                        <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
                                            {localStrings.noChartInCategory}
                                        </Typography>
                                    </div>
                                </Box>
                                :
                                <>
                                {currentTab === 'chartImplementation' &&
                                    <>
                                        {getChartImplementationsInCategory().map((chartImplementation, index) => {
                                            return (
                                                <>

                                                    <ChartPresentationItem
                                                        item={chartImplementation}
                                                        key={index}
                                                        addItemCallBack={(item) => {
                                                            //alert("addChartCallBack")
                                                            addChartToBoardCallBack(item)
                                                        }}
                                                    />
                                                    <Divider/>
                                                </>
                                            )
                                        })
                                        }
                                    </>
                                }

                                    {currentTab === 'dataGridImplementation' &&
                                        <>
                                            {getDataGridImplementationsInCategory()
                                                .map((dataGridImplementation, index) => {
                                                return (
                                                    <>
                                                        <ChartPresentationItem
                                                            item={dataGridImplementation}
                                                            key={index}
                                                            addItemCallBack={(item) => {
                                                                addDataGridToBoardCallBack(item)
                                                            }}
                                                        />

                                                        <Divider/>
                                                    </>
                                                )
                                            })
                                            }
                                        </>
                                    }
                                </>
                            }
                        </Box>
                    </Box>
                </div>
            }
        </>
    )
}

export default ChartSelector